import React from "react";
import { useTranslation } from "react-i18next";

import './about.css';

import about_img from './27175321_i9uq_jks3_220416.jpg';
import { FaCheckCircle } from "react-icons/fa";


const About = () => {

    const { t } = useTranslation();

    return (
        <>

            <section id="about_section">

                <div id="about_img_div">
                    <img id="about_img" src={about_img} alt="" />
                </div>

                <div id="about_txt_div">
                    <h1 id="about_hdng"> {t('about.main_heading')}</h1>

                    <p id="about_txt">
                        {t('about.text')}
                    </p>
                    {/* <span className="points">
                        <FaCheckCircle style={{ color: '#EF4723', fontSize: '17px', marginRight: '7px' }} /> We utilize modern technology and AI for transparency.
                    </span>
                    <span className="points">
                        <FaCheckCircle style={{ color: '#EF4723', fontSize: '17px', marginRight: '7px' }} /> We leverage data insights for informed decison making.
                    </span>
                    <span className="points">
                        <FaCheckCircle style={{ color: '#EF4723', fontSize: '17px', marginRight: '7px' }} /> We Empower Home-owners & buyers with due diligence.
                    </span>
                    <span className="points">
                        <FaCheckCircle style={{ color: '#EF4723', fontSize: '17px', marginRight: '7px' }} /> Supporting you from your first investment to a perfect home.
                    </span> */}
                </div>

            </section>

        </>
    );
};

export default About;